<template>
  <div class="contact">
    <v-container fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" md="3" offset-xs="1">
          <v-card class="contactCard">
            <h2> Nora M. Cielo </h2>
            <p></p>
            <p> Phone: <a href="tel:9084641400"> 908-464-1400 </a></p>
            <p> Email: <a href="mailto:noramcielo@gmail.com">noramcielo@gmail.com </a> </p>
          </v-card>
        </v-col>
        <v-col cols="12" md="3" offset-xs="1">
          <v-card class="contactCard">
            <h2> Erika Ledder Inzano </h2>
            <p></p>
            <p> Phone: <a href="tel:9086729750"> 908-672-9750 </a> </p>
            <p> Email: <a href="mailto:erikainzano@gmail.com">erikainzano@gmail.com </a></p>
          </v-card>
        </v-col>
        <v-col cols="12" md="3" offset-xs="1">
          <v-card class="contactCard">
            <h2> Lucia Carannante </h2>
            <p></p>
            <p> Phone: <a href="tel:9082956111"> 908-295-6111 </a> </p>
            <p> Email: <a href="mailto:fitforlifelucia@gmail.com">fitforlifelucia@gmail.com </a></p>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <h2 class="aptText">Please call for daytime and evening appointments.</h2>
    <p></p><p></p>

    <!-- <v-container grid-list align-center>
      <v-layout row wrap>
        <v-flex xs12 sm12 md5 lg5 offset-xs1>
          <v-img :src="require('../../public/office1.jpg')"></v-img>
        </v-flex>
        <v-flex xs12 sm12 md5 lg5 offset-xs1>
          <v-img :src="require('../../public/office2.jpg')"></v-img>
        </v-flex>
      </v-layout>
    </v-container> -->

  </div>
</template>

<script>

export default {
  name: 'Contact'
}

</script>

<style>

.contact {
  text-align: center;
  font-family: inherit;
}

.contactCard {
  padding: 20px;
}

.aptText {
  text-align: center;
  font-family: inherit;
  margin: 2rem 0;

}
</style>
